/**
 * TabSwitcher Component
 * Tab navigation for Discovery Panel (Search | Recs | Playlist)
 */

import { useEffect, useState } from 'react';
import { Search, Sparkles, ListMusic } from 'lucide-react';
import { useUIStore } from '../../stores/ui';
import { useWorkbenchStore } from '../../stores/workbench';

const TABS = [
  { id: 'search' as const, label: 'Search', icon: Search },
  { id: 'recs' as const, label: 'Recs', icon: Sparkles },
  { id: 'playlist' as const, label: 'Playlist', icon: ListMusic },
] as const;

export function TabSwitcher() {
  const { rightPanelTab, setRightPanelTab } = useUIStore();
  const { activeSlotId } = useWorkbenchStore();
  const [highlightRecs, setHighlightRecs] = useState(false);

  // Highlight Recs tab when active slot changes
  useEffect(() => {
    if (activeSlotId && rightPanelTab === 'recs') {
      setHighlightRecs(true);
      const timer = setTimeout(() => setHighlightRecs(false), 2000);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [activeSlotId, rightPanelTab]);

  return (
    <div className="border-b border-zinc-800 bg-zinc-900/50">
      <div className="flex items-center">
        {TABS.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            onClick={() => setRightPanelTab(id)}
            className={`
              flex-1 flex items-center justify-center gap-2 px-4 py-3 text-sm font-medium
              transition-all duration-200 relative
              ${
                rightPanelTab === id
                  ? 'text-emerald-500'
                  : 'text-zinc-400 hover:text-zinc-200'
              }
              ${id === 'recs' && highlightRecs ? 'animate-pulse ring-2 ring-emerald-500 rounded-t-lg' : ''}
            `}
            aria-current={rightPanelTab === id ? 'page' : undefined}
          >
            <Icon className="w-4 h-4" />
            <span>{label}</span>

            {/* Active indicator */}
            {rightPanelTab === id && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-emerald-500" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
